import React, { useState } from "react";
import { Link } from "react-router-dom";
import { species, heroImages } from "../data/mock";
import { PageHero, SpeciesCard, Reveal, SectionTitle, CTASection } from "../components/common";
import { Button } from "../components/ui/button";

const SpeciesHub = () => {
  const [filter, setFilter] = useState("all");
  const list = species.filter((s) => filter === "all" || s.zone === filter);
  return (
    <>
      <PageHero image={heroImages[1].img} eyebrow="Species Guide" title="Fish Species of San Juan del Sur" sub="The Pacific waters off Nicaragua hold an extraordinary variety of game fish year-round. Discover what you can target and when." />
      <section className="py-14">
        <div className="container-x">
          <div className="flex gap-2 mb-8">
            {[["all","All Species"],["offshore","Offshore"],["inshore","Inshore"]].map(([k,l]) => (
              <button key={k} onClick={() => setFilter(k)} className={`rounded-full px-5 py-2 text-sm font-heading transition ${filter===k?"bg-[#f5a524] text-[#0a1f33]":"bg-[#0e2740] text-slate-200 border border-white/10 hover:bg-white/10"}`}>{l}</button>
            ))}
          </div>
          <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((s, i) => (<Reveal key={s.slug} delay={(i%3)*0.06}><SpeciesCard s={s} /></Reveal>))}
          </div>
          <div className="mt-12 grid md:grid-cols-2 gap-4">
            <Link to="/offshore-species" className="rounded-2xl border border-white/10 bg-gradient-to-r from-[#123a5c] to-[#0e2740] p-6 card-hover">
              <h3 className="font-heading text-2xl text-white">Offshore Species →</h3>
              <p className="text-slate-300 text-sm mt-1">Billfish, tuna, dorado & wahoo in the deep blue.</p>
            </Link>
            <Link to="/inshore-species" className="rounded-2xl border border-white/10 bg-gradient-to-r from-[#0b4f49] to-[#0e2740] p-6 card-hover">
              <h3 className="font-heading text-2xl text-white">Inshore Species →</h3>
              <p className="text-slate-300 text-sm mt-1">Roosterfish, snapper, jacks & mackerel along the coast.</p>
            </Link>
          </div>
          <div className="text-center mt-8"><Link to="/fishing-calendar"><Button variant="outline" className="border-white/20 bg-transparent text-white hover:bg-white/10 hover:text-white">View the Fishing Calendar</Button></Link></div>
        </div>
      </section>
      <CTASection image={heroImages[0].img} />
    </>
  );
};

export default SpeciesHub;
